import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "./gmao";
import { useAuth } from "./auth";

// Contexto de empresa/centro seleccionados, compartido entre pestañas (solo durante la sesión).
const ScopeCtx = createContext(null);
export const useScope = () => useContext(ScopeCtx);

export function ScopeProvider({ children }) {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [installations, setInstallations] = useState([]);
  const [companyId, setCompanyIdState] = useState("");
  const [installId, setInstallId] = useState("");

  const reload = useCallback(() => {
    api.get("/companies").then((r) => setCompanies(r.data)).catch(() => {});
    api.get("/installations").then((r) => setInstallations(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (user) reload();
    else { setCompanies([]); setInstallations([]); setCompanyIdState(""); setInstallId(""); }
  }, [user, reload]);

  useEffect(() => {
    if (!companyId && companies.length === 1) setCompanyIdState(companies[0].id);
  }, [companies, companyId]);

  const companyInstalls = useMemo(
    () => installations.filter((i) => i.company_id === companyId),
    [installations, companyId]
  );

  useEffect(() => {
    if (companyId && !installId && companyInstalls.length === 1) setInstallId(companyInstalls[0].id);
  }, [companyId, companyInstalls, installId]);

  const setCompanyId = useCallback((cid) => { setCompanyIdState(cid); setInstallId(""); }, []);
  const setScope = useCallback((cid, iid) => { setCompanyIdState(cid || ""); setInstallId(iid || ""); }, []);

  const company = companies.find((c) => c.id === companyId) || null;
  const installation = installations.find((i) => i.id === installId) || null;
  const compName = (id) => companies.find((c) => c.id === id)?.nombre_comercial || "—";
  const instName = (id) => installations.find((i) => i.id === id)?.nombre || "—";

  const value = useMemo(() => ({
    companies, installations, companyInstalls, companyId, installId,
    setCompanyId, setInstallId, setScope, company, installation, compName, instName, reload,
  }), [companies, installations, companyInstalls, companyId, installId, setCompanyId, setScope, company, installation]); // eslint-disable-line

  return <ScopeCtx.Provider value={value}>{children}</ScopeCtx.Provider>;
}
